<template>
  <q-dialog ref="dialog"
            :position="position"
            :persistent="persistent"
            :transition-show="transitionShow"
            :transition-hide="transitionHide"
            v-on="$listeners" >
    <slot/>
  </q-dialog>
</template>

<script>
export default {
  name: 'RDialog',
  props: {
    position: String,
    persistent: Boolean,
    transitionShow: String,
    transitionHide: String,
  },
  methods: {
    show() {
      this.$refs.dialog.show();
    },
    hide() {
      this.$refs.dialog.hide();
    },
  },
};
</script>
